(function ($) {

    $(function () {

        // Set up dynamic-height stuck style for ancillary nav.
        var ancillaryNavHeight = $(".endicott-header-ancillary-nav-container-outer").outerHeight();
        var stuckStyleTag = document.createElement("style");
        stuckStyleTag.type = "text/css";
        stuckStyleTag.innerHTML =
            "@media (min-width: 1400px) {\r\n" +
            "    .endicott-header-2024.stuck { transform: translateY(-" + ancillaryNavHeight + "px); }\r\n" +
            //"    html.header-2024-stuck .hero-wrapper { margin-top: -" + ancillaryNavHeight + "px; }\r\n" +
            "}";
        document.getElementsByTagName('head')[0].appendChild(stuckStyleTag);

        // Sticky scroll handler for hiding ancillary nav when scrolled down on the page.
        window.handleHeaderPageScroll = function () {
            if ($(window).scrollTop() > 0) {
                $(".endicott-header-2024").addClass("stuck");
                $("html").addClass("header-2024-stuck");
            }
            else {
                $(".endicott-header-2024").removeClass("stuck");
                $("html").removeClass("header-2024-stuck");
            }
        }

        $(window).on("scroll", $.throttle(100, false, function () {
            handleHeaderPageScroll();
        }));

        $(window).on("resize", $.throttle(100, false, function () {
            handleHeaderPageScroll();
        }));

        // Click event for desktop main menu flyouts
        $(".endicott-header-main-nav-dropdown-link").click(function () {

            disableParentOverflow();

            var $this = $(this);
            var $clickedLink = $this;

            // Close/inactivate any other main menu flyouts/links
            $(".endicott-header-main-nav-item").each(function () {
                var $this = $(this);
                if (!$this.is($clickedLink.parent().parent())) {
                    $this.removeClass("active");
                }
            });

            // Toggle opening/activation of the clicked link/flyout
            $clickedLink.parent().parent().toggleClass("active");
            setMobilHeaderMenuHeight();


        });

        // Click outside the desktop main menu flyout to close it
        $(document).on("click", function (event) {
            if (!$(event.target).is(".endicott-header-main-nav-dropdown-link")) {
                var $mainNavFlyoutMenuAncestor = $(event.target).closest(".endicott-header-main-nav-item");
                if (!$mainNavFlyoutMenuAncestor.length) {
                    var $mainNavItems = $(".endicott-header-main-nav-item");
                    $mainNavItems.each(function () {
                        var $this = $(this);
                        if ($this.hasClass("active")) {
                            $this.removeClass("active");
                        }
                    });
                }
            }
        });

        // Click event for mobile main menu flyout opening
        $("#endicott-header-mobile-menu-open-button").click(function () {

            enableBodyFix();

            var $openButton = $("#endicott-header-mobile-menu-open-button");
            var $closeButton = $("#endicott-header-mobile-menu-close-button");

            // Toggle opening/activation of the mobile main menu and control button transformation
            $(".endicott-header-nav-container").addClass("open");
            $openButton.addClass("menu-open");
            $(".endicott-header-mobile-secondary-nav-container-outer").addClass("main-menu-open");

            setTimeout(() => {
                $openButton.addClass("menu-open-transitioned");
                $closeButton.addClass("menu-open");
                setTimeout(() => {
                    $closeButton.addClass("menu-open-transitioned");
                }, 500);
            }, 500);

        });

        // Click event for mobile main menu flyout closing
        $("#endicott-header-mobile-menu-close-button").click(function () {

            reenableParentOverflow();

            var $openButton = $("#endicott-header-mobile-menu-open-button");
            var $closeButton = $("#endicott-header-mobile-menu-close-button");

            // Toggle opening/activation of the mobile main menu and control button transformation
            $(".endicott-header-nav-container").removeClass("open");
            $(".endicott-header-nav-container").css("overflow-y", "auto");
            disableBodyFix();
            $closeButton.removeClass("menu-open-transitioned");
            $closeButton.removeClass("menu-open");
            $closeButton.addClass("menu-closing");
            $(".endicott-header-mobile-secondary-nav-container-outer").removeClass("main-menu-open");
            setTimeout(() => {
                $closeButton.removeClass("menu-closing");
                $openButton.removeClass("menu-open-transitioned");
                $openButton.removeClass("menu-open");
            }, 500);

            //trigger the equivalent actions for closing any given menu
            $(".endicott-header-main-nav-item").removeClass("active");
        });

        // Click event for mobile main menu second-level flyout closing
        $(".dropdown-menu-back-link").click(function () {
            reenableParentOverflow();

            var $this = $(this);
            $this.closest(".endicott-header-main-nav-item").removeClass("active");
        });

        // Click event for mobile secondary navigation flyout opening/closing
        $(".endicott-header-mobile-secondary-nav-top-link").click(function (event) {

            var $container = $(".endicott-header-mobile-secondary-nav-container-outer");
            if (!$container.hasClass("open")) {
                enableBodyFix();
                $container.addClass("open");
            }
            else {
                disableBodyFix();
                $container.removeClass("open");
            }
            event.preventDefault();

        });

        // Click outside the mobile secondary navigation flyout to close it
        $(document).on("click", function (event) {
            if (!$(event.target).is(".endicott-header-mobile-secondary-nav-top-link")) {
                var $secondaryNavFlyoutMenuAncestor = $(event.target).closest(".endicott-header-mobile-secondary-nav-child-links-container-outer");
                if (!$secondaryNavFlyoutMenuAncestor.length) {
                    var $secondaryNav = $(".endicott-header-mobile-secondary-nav-container-outer");
                    if ($secondaryNav.hasClass("open")) {
                        $secondaryNav.removeClass("open");
                    }
                }
            }
        });

        window.addEventListener('show.modal', function (e) {
            //console.log(e.detail.relatedTarget);
            //console.log(e.detail.modal);
            var $relatedTargetParent = $(e.detail.relatedTarget).parent();
            if ($relatedTargetParent.hasClass("endicott-header-navextras-container")) {
                $("#main-search-box").focus();
            }
        }, false);

        function reenableParentOverflow() {
            $('.endicott-header-nav-container').removeClass("overflow-y-hidden");
        }

        function disableParentOverflow() {
            $('.endicott-header-nav-container').addClass("overflow-y-hidden");
        }

        function enableBodyFix() {
            $('body').addClass("modal-open");
        }

        function disableBodyFix() {
            $('body').removeClass("modal-open");
        }

        window.setMobilHeaderMenuHeight = function () {
            //TODO this needs to be limited to only mobile before it can be implemented, otherwise it affects desktop
            /*
            if ($('.endicott-header-main-nav-item.active').length) {
                var headerHeight = $('.endicott-header-main-container-outer').outerHeight();
                $('.endicott-header-main-nav-item.active .dropdown-menu').css("height", "calc(100vh - " + headerHeight + "px)");
            }
            else {
                $('.endicott-header-main-nav-item.active .dropdown-menu').css("");
            }
            */
        }

        $(window).on("resize", $.throttle(400, true, function () {
            setMobilHeaderMenuHeight();
        }
        ));

        setMobilHeaderMenuHeight();
    });

})($JQ);